import {useCollection} from "@/app-autocomplete/hooks/useCollection.ts";
import {useCustomizedUrl} from "@/hooks/useCustomizedUrl.ts";
import {useTranslations} from "@/hooks/useTranslations.ts";
import {useAutocomplete} from "../providers/AutocompleteProvider.tsx";
import {Panel} from "./Panel.tsx";

export function Categories() {
    const {autocomplete} = useAutocomplete();
    const customizedUrl=useCustomizedUrl();
    const tc = useTranslations();
    const { items, source } = useCollection("staticCategoriesPlugin");
    if (items.length === 0) return <></>;
    return (
        <>
            {items.length > 0 && (
                <Panel title={tc.categories}>
                    <ul className="aa-categories" {...autocomplete.getListProps({
                        source: source
                    })}>
                        {items.map((item, itemIndex) => (
                            <li key={itemIndex} className="aa-categories__item" {...autocomplete.getItemProps({
                                item: item,
                                source: source
                            })}>
                                <a href={`/${customizedUrl}/${item.slug}`}>
                                    {item.icon &&
                                        <img alt={item.name} loading="lazy"
                                             src={ item.icon} width={55}
                                             height={55} aria-hidden={true}/>}
                                    <span  dangerouslySetInnerHTML={{__html: item.highlightedName}}/>
                                </a>
                            </li>
                        ))}
                    </ul>
                </Panel>
            )}
        </>
    );
}
